<script>
import i18n from '@plugins/i18n';

import { Collection, ExchangeCollection } from '@/models';

import Search from './Search.vue';

export default {
    name: 'Exchange',
    extends: Search,
    props: {
        label: {
            type: String,
            default: i18n.t('exchange')
        },
        collection: {
            type: Collection,
            default: () => new ExchangeCollection()
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: String,
            default: 'name'
        },
        itemDescription: {
            type: String,
            default: 'short_name'
        },
        testId: {
            type: [String, Object],
            default: 'exchange_selector'
        }
    },
    data: () => ({
        // createForm: () => import('@/components/forms/CreateExchange.vue')
    })
};
</script>
